module.exports = __webpack_public_path__ + "img/x-close.62b96fda.svg";